<template>
    <div>
        <tab name="2">{{data && data.idNameVO && data.idNameVO.name}}(ID:{{id}})</tab>
        <user-media :data.sync="data" v-loading="listLoading" :userType="3" @getDataList="getDataList"></user-media>
    </div>
</template>

<script>
import Tab from './components/tab';
import UserMedia from '@/views/user/components/user-media';
export default {
    props:{
        id:{
            type:[Number,String],
            default: ''
        }
    },
    components:{
        Tab,UserMedia
    },
    data() {
        return {
            data: null,
            dataList: null,
            listLoading: false, 
        };
    },
    mounted(){
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/site/media",
                method: "POST",
                data: {
                    id:this.id
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.media;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
    }
}
</script>